import { Tab } from "@headlessui/react";
import { useEffect } from "react";
import { Fragment } from "react";
import OrdersHomeScreen from "../OrdersDetail/OrdersHomeScreen";
import OrderPendingScreen from "../OrdersDetail/OrdersPendingScreen";
import { useParams } from "react-router-dom";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import usePermission from "src/hooks/usePermission";
import { toast } from "src/hooks/useToast";
//M10-12287
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/context/store";
import InvoiceUploadModal from "./InvoiceUploadModal";
import PoOrderScreen from "../OrdersDetail/PoOrderScreen";  //M10-12866
import UploadIcon from "src/assets/upload.svg";
import { Button } from "src/components";
import { ordActions } from "src/context/order-slice";
import OrderBulkUpload from "../OrdersDetail/order-bulk-upload/order-bulk-upload";
//M10-12287

let tabs = ["Counters", "Orders", "PO"];  //M10-12866

const OrdersHomePage = () => {
  const { hasPermission: viewOrdersPermission, loading: isPermissionLoading } = usePermission({
    module: fineGrainedPermissionsKeys.ORDER.DETAILS_ALL.module,
    action: fineGrainedPermissionsKeys.ORDER.DETAILS_ALL.action,
  });

  useEffect(() => {
    if (!isPermissionLoading && viewOrdersPermission === false) {
      tabs = tabs.filter((tab) => tab !== "Orders");
      toast({
        variant: "destructive",
        description: "You don't have permission to view Orders",
      });
    }
  }, [isPermissionLoading, viewOrdersPermission]);

  const dispatch = useDispatch();
  const modalOpen = useSelector((state: RootState) => state.ord.fileUpload);  //M10-12287
  const bulkOrderUploadModal = useSelector((state: RootState) => state.ord.bulkOrderUploadModal);
  const { tabIndex } = useParams();
  return (
    <div>
      <section>
        <header className="flex px-[3.75rem] items-center justify-between py-5">
          <div>
            <h1 className="text-[#49484C] font-bold text-[2rem]">Orders</h1>
            <p className="font-medium text-base text-[#929194]">View and manage all your orders.</p>
          </div>
        </header>

        {/* table  */}
        <main>
          <Tab.Group defaultIndex={tabIndex ? parseInt(tabIndex) : 1}>
            <Tab.List className="flex items-center justify-between border-b-[1px] shadow-md border-b-[rgba(0, 0, 0, 0.10)] mb-[1.16rem] px-[3.75rem] mt-6">

              {/* LEFT SIDE (Tabs) */}
              <div className="flex">
                {tabs.map((item: string) => (
                  <Tab key={item} as={Fragment}>
                    {({ selected }: { selected: boolean }) => (
                      <div
                        className={`relative inline-block cursor-pointer -bottom-[1px] px-4 py-3 font-semibold text-sm border-b-2 not-italic hover:border-b-[#586AF5] hover:text-[#586af5] focus:outline-none ${selected
                          ? "text-[#586af5] border-b-[#586AF5]"
                          : "text-[rgba(0,0,0,0.4)] border-b-transparent"
                          }`}
                      >
                        {item}
                      </div>
                    )}
                  </Tab>
                ))}
              </div>

              {/* RIGHT SIDE (Button) */}
                <Button
                  onClick={() => dispatch(ordActions.setBulkOrderUploadModal(true))}
                  className="gap-2 mb-3 border transition-all duration-300 ease-in-out hover:bg-gray-100"
                  module={fineGrainedPermissionsKeys.ORDER.ORDERBULKUPLOADKAM.module}
                  action={fineGrainedPermissionsKeys.ORDER.ORDERBULKUPLOADKAM.action}
                >
                  <img src={UploadIcon} alt="Upload" width={12} height={12} />KAM Bulk Upload
                </Button>

            </Tab.List>

            <Tab.Panels>
              <Tab.Panel className="px-[3.75rem]">
                <OrdersHomeScreen />
              </Tab.Panel>
              {(isPermissionLoading || viewOrdersPermission) && (
                <Tab.Panel className="px-[3.75rem]">
                  {!isPermissionLoading && viewOrdersPermission && <OrderPendingScreen />}
                </Tab.Panel>
              )}
              {/* M10-12866 */}
              <Tab.Panel className="px-[3.75rem]">
                <PoOrderScreen />
              </Tab.Panel>
              {/* M10-12866 */}
            </Tab.Panels>
          </Tab.Group>
        </main>
      </section>
      {/* M10-12287  */}
      <InvoiceUploadModal
        modalOpen={modalOpen}
      />
      {/* M10-12287 */}
      {bulkOrderUploadModal && <OrderBulkUpload />}
    </div>
  );
};

export default OrdersHomePage;
